export default "__VITE_ASSET__CHxIwc5B__"